import { createUseStyles } from 'react-jss';

const DefaultStyles = createUseStyles((theme) => {
  const { fontFamily, fontSize } = theme;
  return {
    wdsDefaultStyles: {
      fontFamily: fontFamily.base,
      '-webkit-font-smoothing': 'antialiased',
      fontSize: fontSize.body,
      boxSizing: 'border-box',
      padding: 0,
      margin: 0,
      listStyle: 'none',
    },
  };
});

export default DefaultStyles;
